<template>
  <div>

    <modal
      title="Delete Spot Rates"
      :submit="submit"
      submit-label="Delete"
      :submitting="submitting"
    >

      <p>Are you sure you want to delete the spot rates for this event?</p>

    </modal>

  </div>
</template>

<script setup lang="ts">

import { ref } from 'vue'

// models
import { EventTier } from '../../../../../models/EventTier'

// misc
import NotificationService from '../../../../../services/NotificationService'
// @ts-ignore
import { closeDialog } from 'vue3-promise-dialog'

interface Props {
  inventoryId: number
}

const props = defineProps<Props>()

/**
 * Submission
 */

const submitting = ref(false)

function submit() {

  submitting.value = true

  EventTier.mutate({
    operations: [{
      inventory_id: props.inventoryId,
      tiers: [],
    }]
  }).then(() => {
    NotificationService.success('Tiered pricing deleted')
    closeDialog(true)
  }).catch((error) => {
    console.error(error)
    NotificationService.error('Couldn\'t delete tiered pricing!')
  })
  .finally(() => {
    submitting.value = false
  })

}

</script>
